const clampRating = (value) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return null;
  }

  return Math.min(Math.max(numericValue, 0), 5);
};

export const getEffectiveInfluencerRating = ({
  rating,
  reviewCount,
  isVerified,
} = {}) => {
  const numericReviewCount = Number(reviewCount);
  const hasCompanyRatings =
    Number.isFinite(numericReviewCount) && numericReviewCount > 0;

  if (hasCompanyRatings) {
    return clampRating(rating);
  }

  if (isVerified) {
    return 5;
  }

  return clampRating(rating);
};

export const formatInfluencerRating = (
  ratingValue,
  { fallback = "—", fractionDigits = 1 } = {}
) => {
  if (!Number.isFinite(ratingValue)) {
    return fallback;
  }

  return Number(ratingValue).toFixed(fractionDigits);
};

export const applyInfluencerRatingFallback = (influencer) => {
  if (!influencer || typeof influencer !== "object") {
    return influencer;
  }

  const effectiveRating = getEffectiveInfluencerRating({
    rating: influencer.rating,
    reviewCount: influencer.reviewCount,
    isVerified: influencer.isVerified,
  });

  if (!Number.isFinite(effectiveRating)) {
    return influencer;
  }

  return {
    ...influencer,
    rating: effectiveRating,
  };
};
